import {Platform, StyleSheet} from 'react-native';

const THEME = {
  dish: { bg: '#2E7D32', bgPressed: '#1B5E20' },  // ConsumeGetEatFromProvider Well - green
  live: { bg: '#1565C0', bgPressed: '#0D47A1' },  // ConsumeGetLiveFromProvider Well - blue
  move: { bg: '#EF6C00', bgPressed: '#E65100' },  // ConsumeGetMoveFromProvider Forward - orange
};
const HEADER_COLORS = {
  bg: '#F2F5FA',     // light cool-gray (not blue), contrasts gently with blue
  text: '#0F172A',   // near-black for strong readability
  border: '#D8E1EE', // soft cool-gray border
};

const poststyles = StyleSheet.create({



  tabContainer: {
    flexDirection: 'row',
    marginHorizontal: 10,
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#F3F4F6',
    borderRadius: 999,
    padding: 6,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  tabButton: {
    flex: 1,
    paddingVertical: 10,
    paddingHorizontal: 10,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 999,
  },
  tabButtonActive: {
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 2,
  },
  tabButtonPressed: {
    opacity: 0.92,
    transform: [{ scale: 0.99 }],
  },
  tabText: {
    fontWeight: '800',
    color: '#6B7280',
    fontSize: 12,
    letterSpacing: 0.2,
  },
  tabTextActive: {
    color: '#111827',
  },
  tabIndicator: {
    marginTop: 6,
    height: 3,
    width: 18,
    borderRadius: 999,
    backgroundColor: 'transparent',
  },
  tabIndicatorActive: {
    backgroundColor: '#0A84FF',
  },

  subHeading: {
    marginTop: 6,
    marginHorizontal: 10,
    fontSize: 16,
    fontWeight: '800',
    color: '#111827',
  },

  stepHeader: {
    marginTop: 10,
    marginHorizontal: 10,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 12,
    backgroundColor: '#F5F9FF',
    borderWidth: 1,
    borderColor: 'rgba(10, 132, 255, 0.18)',
  },
  stepTitle: {
    fontSize: 12,
    fontWeight: '800',
    color: '#1F2937',
    letterSpacing: 0.15,
  },

  label: {
    fontSize: 12,
    fontWeight: '600',
    color: '#111827',
    marginBottom: 6,
  },

  input: {
    borderWidth: 1,
    borderColor: '#D1D5DB',
    borderRadius: 12,
    paddingHorizontal: 14,
    paddingVertical: 12,
    backgroundColor: '#fff',
  },
  inputText: {
    fontSize: 12,
    color: '#111827',
    fontWeight: '500',
  },
  inputError: {
    borderColor: '#d32f2f',
  },

  helperRow: {
    marginTop: 8,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },
  helperText: {
    flex: 1,
    fontSize: 10,
    lineHeight: 18,
    color: '#4B5563',
  },
  counterText: {
    fontSize: 12,
    color: '#6B7280',
  },
  errorText: {
    color: '#d32f2f',
    marginTop: 12,
    fontSize: 12,
    lineHeight: 18,
    fontWeight: '600',
  },

  chipRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 12,
  },
  chip: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 999,
    backgroundColor: '#F3F4F6',
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  chipPressed: {
    backgroundColor: '#E8F1FF',
    borderColor: 'rgba(10, 132, 255, 0.25)',
  },
  chipText: {
    fontSize: 12,
    color: '#111827',
    fontWeight: '600',
  },

  navRow: {
    marginTop: 16,
    marginHorizontal: 10, // NEW: aligns buttons to the same "whole section" width as your inputs/tabs
    flexDirection: 'row',
    gap: 12,
  },

  navButton: {
    flex: 1,     // NEW: each button takes 50% of the available section width (minus the gap)
    minWidth: 0, // NEW: prevents overflow issues on small screens
  },

  navButtonPressed: {
    transform: [{ scale: 0.99 }],
    opacity: 0.95,
  },
  navPrimaryPressed: {
    transform: [{ scale: 0.99 }],
    opacity: 0.92,
  },
  navIcon: {
    fontSize: 12,
    fontWeight: '800',
    lineHeight: 18,
  },
  navIconPrimary: {
    color: '#FFFFFF',
  },
  navIconSecondary: {
    color: '#111827',
  },
  navIconDisabled: {
    color: '#9CA3AF',
  },

  primaryButtonText: {
    color: '#fff',
    fontWeight: '800',
    fontSize: 12,
    letterSpacing: 0.2,
  },
  secondaryButtonText: {
    color: '#111827',
    fontWeight: '800',
    fontSize: 12,
    letterSpacing: 0.2,
  },
  buttonTextDisabled: {
    color: '#9CA3AF',
  },
  buttonTextDisabledOnPrimary: {
    color: '#F9FAFB',
    opacity: 0.9,
  },

});

export default poststyles;
